/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * appHeader
 */

import scrollMonitor from 'scrollmonitor';

const delay = ms => new Promise(_ => setTimeout(_, ms));

const appHeader = {
    cfg: {
        body: document.getElementsByTagName('body')[0],
        appHeader: document.querySelector('.js-appHeader'),
        mainNav: document.querySelector('.js-menu'),
        navWrapper: document.querySelector('.js-wrapper'),
        navBarToggle: document.querySelector('.js-navbarToggle'),
        section: document.querySelectorAll('.o-section--cb'),
    },

    init() {
        if (this.cfg.navBarToggle) {
            this.cfg.navBarToggle.addEventListener('click', () => {
                this.cfg.navWrapper.classList.toggle('active');
                this.cfg.navBarToggle.classList.toggle('active');

                if (this.cfg.navBarToggle.classList.contains('active')) {
                    this.cfg.mainNav.classList.add('active');
                    this.cfg.body.classList.add('is-open--navigation');
                } else {
                    delay(700).then(() => this.cfg.mainNav.classList.remove('active'));
                    this.cfg.body.classList.remove('is-open--navigation');
                }
            });

            document.addEventListener('click', (e) => {
                let targetElement = e.target;

                do {
                    if (targetElement === this.cfg.navWrapper || targetElement === this.cfg.navBarToggle) {
                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                } while (targetElement);

                if (this.cfg.navBarToggle.classList.contains('active')) {
                    this.cfg.navWrapper.classList.remove('active');
                    this.cfg.navBarToggle.classList.remove('active');
                    delay(700).then(() => this.cfg.mainNav.classList.remove('active'));
                    this.cfg.body.classList.remove('is-open--navigation');
                }
            });

            if (this.cfg.section[0]) {
                const elementWatcher = scrollMonitor.create(this.cfg.section[0]);

                // elementWatcher.lock();

                elementWatcher.exitViewport(() => {
                    this.cfg.appHeader.classList.add('o-appHeader--background');
                    // this.cfg.stickyButton.classList.add('is-visible');
                });

                elementWatcher.enterViewport(() => {
                    this.cfg.appHeader.classList.remove('o-appHeader--background');
                    // this.cfg.stickyButton.classList.remove('is-visible');
                });
            } else {
                this.cfg.appHeader.classList.add('o-appHeader--background');
            }
        }
    }
};

export default appHeader;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/appHeader/_script.js